module.exports = __webpack_public_path__ + "static/media/AgreementA.26b612ff.svg";